<template>
    <div class="main_center" style="margin: 0 0;padding-top: 8px;">
        <div class="content" style="padding: 16px 16px 5px 16px;">
            <el-form ref="form" :model="form" label-position="left" >
                <el-row :gutter="16">
                    <el-col :span="6">
                        <el-form-item label="统计维度：" label-width="70px">
                            <el-select v-model="form.type" value-key="value" @change="typeListChange"
                                       style="width: 100%">
                                <el-option v-for="(item, index) of typeList" :key="index" :label="item.name"
                                           :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item v-show="typeValue === 1" label="时间周期：" props="dateTime1" label-width="70px">
                            <el-date-picker
                                v-model="form.dateTime1"
                                type="month"
                                format="yyyy-MM"
                                value-format="yyyy-MM"
                                placeholder="选择月"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item v-show="typeValue === 2" label="时间周期：" props="dateTime2" label-width="70px">
                            <el-date-picker
                                v-show="typeValue === 2"
                                v-model="form.dateTime2"
                                type="year"
                                format="yyyy"
                                value-format="yyyy"
                                placeholder="选择年"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item v-show="typeValue === 3" label="时间周期：" props="dateTime3" label-width="70px">
                            <el-date-picker
                                v-show="typeValue === 3"
                                v-model="form.dateTime3"
                                type="daterange"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
<!--                    <el-col :span="7">-->
<!--                        <el-form-item label="招标公告发布时间：" props="tradeId" label-width="140px">-->
<!--                            <el-date-picker-->
<!--                                v-model="form.tenderTime"-->
<!--                                type="daterange"-->
<!--                                format="yyyy-MM-dd HH:mm:ss"-->
<!--                                value-format="yyyy-MM-dd HH:mm:ss"-->
<!--                                placeholder="选择招标公告发布时间"-->
<!--                                style="width: 100%"-->
<!--                            ></el-date-picker>-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
                    <el-col :span="4">
                        <el-form-item label="所属交易中心：" props="tradeId" label-width="100px">
                            <el-select v-model="form.tradeId" clearable value-key="value" style="width: 100%"
                                       @change="searchBtn">
                                <el-option v-for="(item, index) in transactionCenterList" :key="index"
                                           :label="item.orgName"
                                           :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="评定分离项目：" props="tradeId" label-width="100px">
                            <el-select v-model="form.isassessmentseparation" clearable style="width: 100%"
                                       @change="searchBtn">
                                <el-option v-for="(item, index) of assessmentSeparationList" :key="index"
                                           :label="item.name"
                                           :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否远程异地：" props="isRemote" label-width="100px">
                            <el-select v-model="form.isRemote" clearable style="width: 100%"
                                       @change="searchBtn">
                                <el-option v-for="(item, index) of assessmentSeparationList" :key="index"
                                           :label="item.name"
                                           :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="" label-width="0">
                            <div>
                                <!-- <el-button plain size="small" type="primary" @click="refresh">重置</el-button> -->
                                <el-button size="small" type="primary" @click="searchBtn">统计</el-button>
                                <el-button size="small" type="primary" @click="exportExcel">导出excel</el-button>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <space :left="-16" :right="-16" :bottom="16"/>
            <!-- @sort-change="sortChange" -->
            <el-table size="small" :data="tableData" v-loading="dataListLoading" ref="expertExtractTable"
                      :height="tableMaxHeight" stripe border>
                <el-table-column
                    label="序号"
                    type="index"
                    fixed
                    :index="indexMethod"
                    width="50"
                    align="center"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column label="项目编号" prop="tenderProjectCode" align="left" width="120"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="项目名称" prop="tenderProjectName" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="项目标段编号" prop="bidSectionCode" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="项目标段名称" prop="bidSectionName" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="项目所在地" prop="projectLocation" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="是否十大工程" prop="isTenProject" align="left" width="200"
                                 :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{ scope.row.isTenProject == 1 ? "是" : "否" }}
                    </template>
                </el-table-column>
                <el-table-column label="十大工程类别" prop="isTenType" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column
                    label="上传投标文件家数"
                    prop="uploadBidDocumentsNum"
                    align="left"
                    width="200"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    label="应收投标保证金金额（万元）"
                    prop="receivableEarnestMoney"
                    align="left"
                    width="220"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    label="实收投标保证金金额（万元）"
                    prop="officialReceiptsEarnestMoney"
                    align="left"
                    width="220"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    label="免收（降低）投标保证金成效（万元）"
                    prop="freeBidEarnestMoney"
                    align="left"
                    width="260"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    label="免收履约保证金成效（万元）"
                    prop="freeBondEarnestMoney"
                    align="left"
                    width="220"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    label="降低工程质量保证金成效（万元）"
                    prop="reduceProjectEarnestMoney"
                    align="left"
                    width="240"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column label="是否政府采购工程" prop="governmentInvest" align="left" width="200"
                                 :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{ scope.row.governmentInvest == 1 ? "是" : "否" }}
                    </template>
                </el-table-column>
                <el-table-column label="中标人" prop="winerName" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="中标企业类型" prop="bidEnterpriseTypeName" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="行业类型" prop="industryType" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="开标时间" prop="openBidTime" align="left" width="200"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="定标时间" prop="setBidTime" align="left" width="200"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column
                    label="发布中标结果公告时间"
                    prop="bulletinIssuetime"
                    align="left"
                    width="200"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    label="合同估算价（万元）"
                    prop="contractReckonPrice"
                    align="left"
                    width="200"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column label="中标金额（万元）" prop="bidAmount" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="交易方式" prop="tenderModeName" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="组织形式" prop="tenderOrganizeFormName" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="投资主体性质" prop="mainType" align="left" width="200" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{ scope.row.mainType == 1 ? "政府" : "企业" }}
                    </template>
                </el-table-column>
                <el-table-column label="交易类别" prop="tradeTypeName" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="投诉情况" prop="isComplaint" align="left" width="200" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{ scope.row.isComplaint == 1 ? "是" : "否" }}
                    </template>
                </el-table-column>
                <el-table-column label="异议情况" prop="isObjection" align="left" width="200" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{ scope.row.isObjection == 1 ? "是" : "否" }}
                    </template>
                </el-table-column>
                <el-table-column label="招标人" prop="tenderee" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="投标单位列表" prop="applyNameList" align="left" width="500"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="代理机构" prop="tenderAgencyName" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="招标公告发布时间" prop="tenderPublishTime" align="left" width="200"
                                 :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column label="是否远程异地" prop="isRemote" align="left" width="200"
                                 :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{ scope.row.isRemote == 1 ? '是' : (scope.row.isRemote == 0 ? '否' : '全部') }}
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                class="limit"
                :page-sizes="[10, 20, 50, 100]"
                :total="total"
                :page.sync="pageIndex"
                :limit.sync="pageSize"
                @pagination="paginationChange"
            >
            </pagination>
        </div>
    </div>
</template>

<script>
import space from "../../common/components/space.vue";
import Pagination from "@/components/Pagination";
import qs from "qs";
import moment from "moment";

export default {
    name: "expertExtractList",
    components: {
        space,
        Pagination,
    },
    data() {
        return {
            dateTimeList: [
                {name: 1, value: moment().subtract(1, "month").format("YYYY-MM")},
                {name: 2, value: moment().format("YYYY")},
                {
                    name: 3,
                    value: [
                        moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
                        moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
                    ],
                },
            ],
            form: {
                type: 1,
                dateTime1: moment().subtract(1, "month").format("YYYY-MM"),
                dateTime2: moment().format("YYYY"),
                dateTime3: [
                    moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
                    moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
                ],
                tradeId: "", // 交易中心ID
                searchKey: "",
                isassessmentseparation: '',
                isRemote: '',//是否远程异地
                // tenderTime: []
            },
            businessType: "GC",
            moreSearchItem: false,
            typeList: [
                {name: "按月统计", id: 1},
                {name: "按年统计", id: 2},
                {name: "自定义周期", id: 3},
            ],
            typeValue: 1,
            tableData: [],
            pageIndex: 1,
            pageSize: 10,
            total: 0,
            dataListLoading: false,
            tableMaxHeight: document.documentElement.clientHeight - 275,
            inputHtml: "",
            sortParams: {
                prop: "",
                order: "",
            },
            transactionCenterList: [],
            assessmentSeparationList: [
                {name: "全部", id: ""},
                {name: "是", id: 1},
                {name: "否", id: 0},
            ],
        };
    },
    watch: {},
    created() {
        this.transactionCenterList = JSON.parse(sessionStorage.getItem("transactionCenterList"));
        this.transactionCenterList.unshift({orgName: "全部", id: ""});
    },
    methods: {
        ifmove() {
            // let hasBtnPermisson = this.hasBtnPermission('btn_jz_buswitness_'+this.businessType+'del');
            const hasBtnPermisson = false;
            let tableMaxHeight = document.documentElement.clientHeight - 415 + (hasBtnPermisson ? 0 : 41);
            this.pageSize = parseInt(tableMaxHeight / 50) || 1;
            this.$nextTick(() => {
                this.tableMaxHeight = tableMaxHeight;
            });
        },
        exportExcel() {
            const query = qs.stringify(this.dealFilter());
            const url = this.$http.adornUrl(`/api/tradeStatistics/exportStatistics?${query}`);
            window.open(url);
        },
        searchBtn() {
            this.pageIndex = 1;
            this.getList();
        },
        refresh() {
            this.form = {
                year: new Date().getFullYear(),
                searchKey: "",
                tradeId: "", // 交易中心ID
            };
            this.pageIndex = 1;
            this.getList();
        },
        dateTimeChange(val) {
            this.form.dateTime = val;
        },
        typeListChange(val) {
            // const obj = this.dateTimeList.find((item) => item.name === val);
            // this.form.dateTime = obj.value || null;
            this.typeValue = val;
        },
        // 要求前端请求加时间日期
        dealFilter() {
            const st = " 00:00:00";
            const et = " 23:59:59";
            const obj = {
                tradeIds: this.form.tradeId,
                isassessmentseparation: this.form.isassessmentseparation,
                isRemote: this.form.isRemote,
            };
            if (this.typeValue === 1) {
                const ad = moment(this.form.dateTime1).startOf("month").format("DD");
                const ap = moment(this.form.dateTime1).endOf("month").format("DD");
                obj.startTime = this.form.dateTime1 + "-" + ad + st;
                obj.endTime = this.form.dateTime1 + "-" + ap + et;
            }
            if (this.typeValue === 2) {
                obj.startTime = this.form.dateTime2 + "-01-01" + st;
                obj.endTime = this.form.dateTime2 + "-12-31" + et;
            }
            if (this.typeValue === 3) {
                obj.startTime = this.form.dateTime3[0] + st;
                obj.endTime = this.form.dateTime3[1] + et;
            }
            // if (this.form.tenderTime && this.form.tenderTime.length > 0) {
            //     obj.tenderStartTime = this.form.tenderTime[0]
            //     obj.tenderEndTime = this.form.tenderTime[1]
            // }
            return obj;
        },
        getList() {
            this.$http
                .post(`/tradeStatistics/list`, {
                    page: this.pageIndex,
                    rows: this.pageSize,
                    filter: this.dealFilter(),
                })
                .then((res) => {
                    this.tableData = res.data.rows;
                    this.total = res.data.total;
                });
        },
        paginationChange({page, limit}) {
            this.pageIndex = page;
            this.pageSize = limit;
            this.getList();
        },
        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
    },
    activated() {
        this.getList();
    },
    mounted() {
        this.ifmove();
        let resizeTag = true;
        let that = this;
        window.onresize = () => {
            if (resizeTag) {
                //防抖动
                that.ifmove();
                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                }, 1000);
            }
        };
    },
};
</script>
